export const ONE_MINUTE_IN_SECONDS = 60;
export const ONE_HOUR_IN_SECONDS = 3600;
export const ZERO = 0;
export const ONE_SECOND_IN_MILLISECONDS = 1000;
export const DESCRIPTION_CODE_FORM = 'Please click Send code to receive the verification code to your mobile number. Then enter it to the field below.';
